import { Injectable } from '@angular/core';
import { KpiKeys } from '@models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectedKpiService {
  private selectedKpiSubject = new BehaviorSubject<KpiKeys | undefined>(undefined);
  selectedKpi$ = this.selectedKpiSubject.asObservable();

  setSelectedKpi(kpi: KpiKeys | undefined): void {
    this.selectedKpiSubject.next(kpi);
  }
}
